import React from "react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function Services({ onBook }) {
  const ref = useReveal();

  const handleClick = (service) => {
    if (service.id === "group") {
      // Груповата терапия не се записва през онлайн календар — насочваме към контакт
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
      return;
    }
    onBook(service.id);
  };

  return (
    <section className="section" id="services" ref={ref} style={{ paddingTop: "5.5rem" }}>
      <div className="section-head" data-reveal>
        <h2 className="section-title">
          Услуги<span className="annotation">(как работим заедно)</span>
        </h2>
        <span className="section-num">02.</span>
      </div>

      <div data-reveal>
        {services.map((service) => (
          <button
            key={service.id}
            className="service-row"
            onClick={() => handleClick(service)}
            aria-label={service.id === "group" ? `Свържете се за ${service.title}` : `Запазете час за ${service.title}`}
            data-testid={`service-row-${service.id}`}
          >
            <span className="num">{service.index}.</span>
            <span>
              <span className="title">
                {service.title}
                <span className="annotation">{service.annotation}</span>
              </span>
              <span className="service-desc" style={{ display: "block" }}>
                {service.description}
              </span>
            </span>
            <span className="meta">
              {service.duration && <>{service.duration}<br /></>}
              {service.price}
              {service.id === "group" && <>по запитване</>}
            </span>
            <span className="arrow">
              <ArrowUpRight size={18} />
            </span>
          </button>
        ))}
      </div>

      <p
        className="annotation"
        data-reveal
        style={{ marginTop: "2.2rem", fontSize: "1.25rem", color: "var(--ink-soft)" }}
      >
        (натиснете върху услуга, за да запазите час)
      </p>
    </section>
  );
}
